import { render, staticRenderFns } from "./crudLeads.vue?vue&type=template&id=768b57fa&scoped=true&"
import script from "./crudLeads.vue?vue&type=script&lang=js&"
export * from "./crudLeads.vue?vue&type=script&lang=js&"
import style0 from "./crudLeads.vue?vue&type=style&index=0&id=768b57fa&prod&lang=css&"
import style1 from "./crudLeads.vue?vue&type=style&index=1&id=768b57fa&prod&lang=css&"
import style2 from "./crudLeads.vue?vue&type=style&index=2&id=768b57fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768b57fa",
  null
  
)

export default component.exports